// quiz/pendingQuiz.js
//
// Remembers which quiz the user was trying to start while they go through a
// gate (login, DOB, email verification). Only media identifiers are stored —
// never tokens or answers.
//
// localStorage, not sessionStorage: the verification link usually opens in a
// NEW tab, which has its own sessionStorage, so the intent was lost there.
// Scoped to the account that saved it (a guest's intent is adopted by the
// account that signs in); another account never sees it, and logout clears it.

const KEY = 'aluvo_pending_quiz';
const TTL_MS = 24 * 60 * 60 * 1000; // the lifetime of the verification link

export function buildVerifyPath(kind, tmdbId, seasonNumber = null) {
    if (!tmdbId || !['movie', 'tv'].includes(kind)) return null;
    if (kind === 'tv') {
        if (seasonNumber === null || seasonNumber === undefined) return null;
        return `/verify/tv/${encodeURIComponent(tmdbId)}/season/${encodeURIComponent(seasonNumber)}`;
    }
    return `/verify/movie/${encodeURIComponent(tmdbId)}`;
}

export function savePendingQuiz({ kind, tmdbId, seasonNumber = null, sourceScreen = null, mediaTitle = null, userId = null }) {
    const path = buildVerifyPath(kind, tmdbId, seasonNumber);
    if (!path) return null;
    const record = {
        kind, tmdbId: Number(tmdbId), seasonNumber: seasonNumber ?? null, sourceScreen, mediaTitle, path,
        userId: userId ? String(userId) : null, expiresAt: Date.now() + TTL_MS,
    };
    try { localStorage.setItem(KEY, JSON.stringify(record)); } catch { /* ignore */ }
    return record;
}

/** The pending quiz for `userId` (or a guest's, before sign-in), else null. */
export function readPendingQuiz(userId = null) {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const record = JSON.parse(raw);
        if (!record?.path || (record.expiresAt && record.expiresAt < Date.now())) {
            localStorage.removeItem(KEY);
            return null;
        }
        if (record.userId && userId && record.userId !== String(userId)) return null;
        return record;
    } catch {
        return null;
    }
}

export function clearPendingQuiz() {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
